import { Component } from "react"

/* Components */
import { Tag } from "../../components"

/* Widgets */
import Layout from "./Layout"

/* REST API */
import { dealers, toggleDealer } from "../../api/Table"

/* Switch */
import Switch from "react-switch"

/* Swal */
import Swal from "sweetalert2"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"



/* Widget Dealer */
class Dealer extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
        }
    }

    componentDidMount = () => {
        this.load()
    }


    /* Load Dealers Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        dealers({ uid }).then((response) => {
            if (response.status) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }



    /* Change Value */
    change = (dealer, status) => {

        /* Fields */
        const { uid, socket, isRoulette } = this.props
        const { data } = this.state

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        toggleDealer({ uid, dealerID: dealer.id, status }).then((response) => {
            if (response.status === 200) {
                const dealers = data

                const index = dealers.findIndex((e) => parseInt(e.id) === parseInt(dealer.id))

                if (index > -1) {
                    dealers[index].enabled = status ? 1 : 0
                    this.setState({ data: dealers })

                    if (isRoulette) {
                        const activeDealers = dealers.filter((item) => item.enabled === 1).map(({ id, name, uid }) => ({ id, name, uid }))
                        socket.emit("rouletteDealers", activeDealers)
                    }

                }

                Swal.fire(utils.notification(status ? t("dealer.added") : t("dealer.removed"), "success"))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        })

    }


    render = () => {

        const { status, data } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="table--modal-content">

                {data && data.map((item, index) =>
                    <div className="table--dealer-item" key={`${index}`}>

                        <div className="table--dealer-item-text">
                            <h2>{item.name}</h2>
                            <p>{item.uid}</p>
                            <Tag color="pink">{item.pincode}</Tag>
                        </div>

                        <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.change(item, value)} checked={parseInt(item.enabled) === 1} />

                    </div>
                )}

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Dealer)